import React from "react";

import { Landing } from "pages/Sections/Landing";

import { Route, withRouter } from "react-router-dom";

const RouteWrapper = () => {
  return (
    <Route>
      <Landing />
    </Route>
  );
};

export default withRouter(RouteWrapper);
